import { useEffect } from 'react';

import { siteUrl, title as siteTitle } from './data';

function setMeta(selector: string, attr: string, value: string) {
  const el = document.querySelector(selector);
  if (el) {
    el.setAttribute(attr, value);
  }
}

/**
 * Sets the document title, meta description and canonical URL for a page.
 *
 * The site is a single page app, so without this every page reports the same
 * title and description to Google, to LinkedIn link previews and to anyone
 * who bookmarks a page. Search engines then have one indexable record for the
 * whole site instead of one per project.
 */
export default function usePageMeta(pageTitle: string, description: string, path: string) {
  useEffect(() => {
    const fullTitle = pageTitle ? `${pageTitle} — ${siteTitle}` : siteTitle;
    document.title = fullTitle;

    setMeta('meta[name="description"]', 'content', description);
    setMeta('meta[property="og:title"]', 'content', fullTitle);
    setMeta('meta[property="og:description"]', 'content', description);
    setMeta('meta[name="twitter:title"]', 'content', fullTitle);
    setMeta('meta[name="twitter:description"]', 'content', description);

    const url = `${siteUrl}/#/${path}`.replace(/\/#\/$/, '/');
    setMeta('meta[property="og:url"]', 'content', url);

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', url);
  }, [pageTitle, description, path]);
}
